import React from 'react'
import './Form.css'

function Form({SetForm,form}) {
    const handleSubmit=(e)=>{
        e.preventDefault();
        console.log("hello")
    }
  return (
       <div className='form'>
           <form onSubmit={handleSubmit}>
           <div className='top'>
                   <button onClick={()=>SetForm(!form)}>X</button>
                   </div>
               <ol style={{listStyle:"none"}}>
                   <li><label>Name</label></li>
                   <li><input placeholder='User ID'/></li>
                   <li><label> Contact ID</label></li>
                   <li><input placeholder='Mail ID'/></li>
                   <li><label>Mobile Number</label></li>
                   <li><input placeholder='Phone Number'/></li>
                   <li><label>Location</label></li>
                   <li><input placeholder='Location'/></li>
                   <li><label>Type of Issue</label></li>
                   <li>
                   <select placeholder='select your issue' className='issues'>
                   <option>{null}</option>
                   <option>issues</option>
                   <option>issues</option>
                   </select></li>
                   <li><label>Description</label></li>
                   <li><textarea placeholder='Enter Description' rows={5}></textarea></li>
                   <li>Best time to call Back</li>
                   <div className='time-select'>
                   <label>From</label><li><select className='hrs'>
                   <option>{null}</option>
                    {[...Array(25)].map((_, hour) => (
                      <option key={`hour-${hour}`} value={hour}>
                       {hour.toString().padStart(2, '0')}
                      </option>
                      ))}
                  </select></li>
                  <li ><label>To</label></li>
                 <li> <select className='hrs'>
                   <option>{null}</option>
                  {[...Array(24)].map((_, hour) => (
                      <option key={`hour-${hour}`} value={hour}>
                       {hour.toString().padStart(2, '0')}
                      </option>
                      ))}
                       </select></li>
                 </div>
                       <li><button className='btn1' type='submit' ><h4>Send Report</h4></button></li>
               </ol>
               
           </form>
          
      </div>
  
  )
}

export default Form;
